module.exports = __webpack_public_path__ + "static/media/PDF_115.75e192fa.pdf";